import React, { FC } from 'react';
import { View } from 'react-native';
import { scale } from '@components/frame';
import { TRACEABILITY_GRAPH_GEOMETRY, TRACEABILITY_GRAPH_PORT_SIZE } from '@v2/pages/common/components/TraceabilityGraph/constants';
import { TraceabilityGraphProps } from '@v2/pages/common/components/TraceabilityGraph/types';

export const NodePort: FC<Pick<TraceabilityGraphProps, 'C'> & { side: 'left' | 'right' }> = ({ C, side }) => (
  <View
    pointerEvents="none"
    style={{
      position: 'absolute',
      top: '50%',
      marginTop: -scale(TRACEABILITY_GRAPH_GEOMETRY.portRadius),
      ...(side === 'left' ? { left: -scale(TRACEABILITY_GRAPH_GEOMETRY.portRadius) } : { right: -scale(TRACEABILITY_GRAPH_GEOMETRY.portRadius) }),
      width: scale(TRACEABILITY_GRAPH_PORT_SIZE),
      height: scale(TRACEABILITY_GRAPH_PORT_SIZE),
      borderRadius: scale(TRACEABILITY_GRAPH_GEOMETRY.portRadius),
      backgroundColor: C('Link/Light/Primary'),
      borderWidth: scale(1.5),
      borderColor: C('Background/Light/Field'),
      zIndex: 2,
    }}
  />
);
